import { webEnv } from "@/config/webEnv";
import { useAuthStore } from "@roman/shared/store/auth.store";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

const usePageTracking = () => {
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  useEffect(() => {
    if (webEnv.DEV) return;
    if (user) {
      ReactGA.set({ user_id: user.id });
    }
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      user_id: user?.id ?? "guest",
    });
  }, [location, user]);
};

export default usePageTracking;
